module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700px"
    },
    model: {
      value: (_vm.showThresholdHelpDialog),
      callback: function($$v) {
        _vm.showThresholdHelpDialog = $$v
      },
      expression: "showThresholdHelpDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', [(_vm.selectEditServiceId == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.flow-and-time')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.ro-membrane')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.temperature')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.pressure')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('watersystem.differential-pressure')) + "  ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showThresholdHelpDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-flow-and-time-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-ro-membrane-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-temperature-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-pressure-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-differential-pressure-text')) + " ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-dialog-header"
  }, [_vm._v("■" + _vm._s(_vm.$t('watersystem.need-sensor')))]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.flow')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.tds')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.temperature')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.pressure')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.differential-pressure-need-sensor')))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-dialog-header"
  }, [_vm._v("■" + _vm._s(_vm.$t('watersystem.about-threshold-setting')))]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-flow-and-time-text').replace('[UNIT]', this.unit)))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-ro-membrane-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-temperature-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-pressure-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-differential-pressure-text')))]) : _vm._e()], 1), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_blue@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.flow')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_lime@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.time-elapsed')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_alert@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_warning@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": require("../assets/images/inst_wt@3x.png"),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_lightblue@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.entrance-impurity-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_blue@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.exit-impurity-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_alert@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_warning@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": require("../assets/images/inst_ro@3x.png"),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_blue@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.temperature-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_alert@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_warning@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": require("../assets/images/inst_tm@3x.png"),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_line_blue@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.validationType == 0) ? _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.pressure')))]) : _vm._e(), _vm._v(" "), (_vm.validationType == 1) ? _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.differential-pressure-value')))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_alert@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": require("../assets/images/icon_bell_warning@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validationType == 0) ? _c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": require("../assets/images/inst_pr@3x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validationType == 1) ? _c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": require("../assets/images/inst_dp@3x.png"),
      "alt": ""
    }
  }) : _vm._e()])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-5690c786","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpDialog.vue
// module id = 1931
// module chunks = 0